module.exports = __webpack_public_path__ + "img/chocolate.00489359.svg";